import { graphql } from 'react-apollo'
import { Layout, Form, Button, Input, notification, Divider, Table } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import searchTrackingsQuery from '../graphql/queries/searchTrackings'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

class SearchTrackings extends Component {
  state = {
    submitting: false,
    labels: [],
  }
  loadLabels = async () => {
    this.setState({ submitting: true })
    const id = this.props.form.getFieldValue('id')
    try {
      if (id) {
        const { data: { trackings } } = await this.props.trackings.refetch({ code: id })
        console.log(trackings)
        const labels = trackings
        this.setState({ labels })
      }
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
    } finally {
      this.setState({ submitting: false })
    }
  }
  handleInputChange = (e) => {
    this.props.form.setFieldsValue({ [e.target.name]: e.target.value })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Group',
        dataIndex: 'label.group',
        key: 'group',
        width: 150   
      },
      {
        title: 'Label ID',
        key: 'labelId',
        width: 100,
        className: 'text-center',
        render: record => (<span>{record.label._id}<br />({record.label.app})</span>),
      },
      {
        title: 'Recipient',
        dataIndex: 'label.recipient',
        key: 'recipient',
        width: 150,
      },
      {
        title: 'Address',
        dataIndex: 'label.address',
        key: 'address',
      },
      {
        title: 'Count',
        key: 'count',
        width: 60,
        className: 'text-center',
        render: record => record.label.data.count,
      },
      {
        title: 'Items',
        key: 'item',
        width: 200,
        /* eslint react/no-array-index-key: 0 */
        render: record => (
          <ul style={{ paddingLeft: '20px' }}>
            {record.label.data.items && record.label.data.items.map(item => (
              <li key={`${record.label.referenceId} ${item.name}`}>[{item.amount}] {item.name}</li>
            ))}
            {record.label.data.shirts && record.label.data.shirts.map((shirt, index) => (
              <li key={`${record.label.referenceId} ${shirt} ${index}`}>{shirt}</li>
            ))}
          </ul>
        ),
      },
      {
        title: 'Tracking',
        key: 'tracking',
        width: 100,
        className: 'text-center',
        render: record => (record ? <span>[{record.carrier}]<br />{record.code}</span> : '-'),
      },
    ]
    return (
      <Layout>
        <Navbar selected="search:2" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form>
              <FormItem
                {...formItemLayout}
                label="Tracking Id"
              >
                {getFieldDecorator('id', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input id!' }],
                })(
                  <Input type="text" name="id" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.loadLabels} disabled={this.state.submitting}>Search</Button>
              </FormItem>
            </Form>
            <Divider />
            {this.state.labels.length > 0 ? (
              <div>
                <h2>Labels</h2>
                <Table
                  rowKey="_id"
                  dataSource={this.state.labels}
                  columns={columns}
                  pagination={{ pageSize: 50 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
SearchTrackings.propTypes = {
  form: PropTypes.shape(),
}
SearchTrackings.defaultProps = {
  form: {},
}

export default graphql(searchTrackingsQuery, { name: 'trackings', options: { variables: { code: '' } } })(Form.create()(SearchTrackings))



// WEBPACK FOOTER //
// ./src/pages/SearchTrackings.js